import { usePrivy } from '@privy-io/react-auth';
import { handleNotificationsLogout } from '../serviceWorkerRegistration';

import useUserStore from '../stores/user.store';
import useGameStore from '../stores/game.store';
import { isTelegram } from '../utils/browser';

function useCustomLogout() {
  const { logout } = usePrivy();
  const setUser = useUserStore((state) => state.setUser);
  const setGameLoaded = useGameStore((state) => state.setGameLoaded);

  const customLogout = async () => {
    localStorage.setItem('lastUserId', localStorage.getItem('fishAuth') || '');
    handleNotificationsLogout(localStorage.getItem('fishAuth'));
    localStorage.removeItem('fishAuth');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('isGuest');
    await logout();
    setUser(null);
    setGameLoaded(false);

    if (isTelegram) {
      window.Telegram?.WebApp?.close?.();
    }
  };

  return { customLogout };
}

export default useCustomLogout;
